import api from "./api";

const courseService = {
    // GET /api/courses?isActive=true
    getAll: (params = {}) => api.get("/courses", { params }),
    // GET /api/courses/:id
    getById: (id) => api.get(`/courses/${id}`),
    // GET /api/courses/:id/years
    getYearOptions: (id) => api.get(`/courses/${id}/years`),
    // POST /api/courses
    create: (data) => api.post("/courses", data),
    // PUT /api/courses/:id
    update: (id, data) => api.put(`/courses/${id}`, data),
    // DELETE /api/courses/:id
    remove: (id) => api.delete(`/courses/${id}`),
};

export default courseService;